import { gql, useQuery } from '@apollo/client'

import {
  StoreItemCompleteDetailFragmentDoc,
  StoreItemCompleteFreeQuery,
  StoreItemCompleteFreeQueryVariables,
} from '@/clients/utoniq-core/schema'
import { config } from '@/config'
import { useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { convertPortfolioItemToSku } from '@/core/sku'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { router } =
    useRouter<{ artistId: string; itemId: string; skuId?: string }>()
  const artistId = router.query.artistId ?? config.artistId

  const { data, loading } = useQuery<
    StoreItemCompleteFreeQuery,
    StoreItemCompleteFreeQueryVariables
  >(QUERY, {
    variables: { id: router.query.itemId },
  })

  return {
    state: {
      artistId,
      loading,
      itemId: router.query.itemId ?? '',
      portfolio:
        convertPortfolioItemToSku(
          data?.portfolio as never,
          router.query?.skuId
        ) ?? null,
      isFreeItem: data?.portfolio?.item?.price === 0,
    },
    actions: {},
  }
})

const QUERY = gql`
  query StoreItemCompleteFree($id: ID!) {
    portfolio(id: $id) {
      id
      number
      item {
        ...StoreItemCompleteDetail
      }
    }
  }
  ${StoreItemCompleteDetailFragmentDoc}
`
